/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
export default {
  props: {
    vshow: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      isShow: false,
      isMoving: false,
      isActive: false,
      isLeft: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    document.body.addEventListener('touchstart', function () {}); //获取元素
    //            let picture=document.getElementById("floatMenu");

    var picture = this.$el;
    var width = document.body.offsetWidth;
    var height = document.body.offsetHeight; //添加触屏开始事件

    picture.addEventListener("touchstart", function (e) {
      var menuWidth = picture.offsetWidth;
      var menuHeight = picture.offsetHeight;

      var p, _f, f2; //由于触屏的坐标是个数组，所以取出这个数组的第一个元素


      e = e.touches[0]; //保存picture和开始触屏时的坐标差

      p = {
        x: picture.offsetLeft - e.clientX,
        y: picture.offsetTop - e.clientY
      };
      _this.isMoving = true; //                $(document).attr("title",this.clinicList[0].clinicName);
      //                picture.className += ' moving'
      //添加触屏移动事件

      document.addEventListener("touchmove", f2 = function f2(e) {
        _this.isShow = false; //获取保触屏坐标的对象

        var t = e.touches[0]; //把picture移动到初始计算的位置加上当前触屏位置

        var curX = p.x + t.clientX; //当前横坐标

        var curY = p.y + t.clientY; //当前纵坐标
        //                    console.log("curX="+curX + ","+ (width-menuWidth));
        //                    console.log("curY="+curY + ",height - menuHeight=" +(height - menuHeight));
        //计算移动后的 X

        if (curX <= 0) {
          picture.style.left = 0;
        } else if (curX >= width - menuWidth) {
          picture.style.left = width - menuWidth + 'px';
        } else {
          picture.style.left = p.x + t.clientX + "px";
        } //计算移动后的 Y


        if (curY <= 100) {
          picture.style.top = 100 + 'px';
        } else if (curY >= height - menuHeight - 80) {
          picture.style.top = height - menuHeight - 80 + 'px';
        } else {
          picture.style.top = p.y + t.clientY + "px";
        } //阻止默认事件


        e.preventDefault();
      }, false); //添加触屏结束事件

      document.addEventListener("touchend", _f = function f1(e) {
        var g = e.changedTouches[0]; //自动靠边

        var curX = p.x + g.clientX; //当前横坐标

        if (curX >= width / 2) {
          picture.style.left = width - menuWidth - 0.3 * window.rem + 'px';
        } else {
          picture.style.left = 0.3 + "rem";
        }

        _this.isMoving = false; //移除在document上添加的两个事件

        document.removeEventListener("touchend", _f);
        document.removeEventListener("touchmove", f2);
      }, false);
    }, false);
  },
  methods: {
    goCart: function goCart() {
      this.$router.push({
        name: 'MallShopCart'
      });
    }
  }
};